import type {UseQueryResult} from '@tanstack/react-query';
import {useQuery} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {CapacityLabel} from '@/types/CapacityLabel';
import {apiUrl} from '@/utils/api';

export const useGetCapacityLabels = () : UseQueryResult<CapacityLabel[]> => {
    const fetch = useApiFetch();

    return useQuery(['capacityLabels'], async ({signal}) => {
        const response = await fetch(
            apiUrl('/v1/capacity/capacity/labels').toString(),
            {
                signal,
            }
        );

        if (!response.ok) {
            throw new Error('Unable to fetch capacity labels.');
        }

        return await response.json() as CapacityLabel[];
    });
};
